<template>
  <view-loader :loading="!!loading">
    <div class="portlet-body form">
      <form class="form-horizontal" role="form">
        <div class="form-body">
          <h3 class="form-section" style="margin-top: 0">{{ 'job.new' | trans }}</h3>
          <div class="row margin-bottom-20">
            <div class="col-md-12">
              <div class="form-group">
                <label class="col-md-2 control-label">{{ 'job.create.type' | trans }}:</label>
                <div class="col-md-10">
                  <single-select
                      v-model="selectedType"
                      :allow-empty="true"
                      :options="jobTypes"
                      name="jobTypes"
                  />
                </div>
              </div>
            </div>
          </div>
          <component
              :is="selectedTypeOption.component"
              v-if="selectedTypeOption"
              :component="selectedTypeOption.id"
              v-bind="selectedTypeOption.props"
              @loading="showLoader"
          />
        </div>
      </form>
    </div>
  </view-loader>
</template>

<script>
import { JOB_TYPES } from '@const/job.js'
import SingleSelect from '@component/singleselect.vue'
import ViewLoader from '@component/ViewLoader.vue'

export default {
  name: 'CreateJob',
  components: {
    ViewLoader,
    SingleSelect,
  },
  data() {
    return {
      selectedType: null,
      loading: false,
    }
  },
  computed: {
    selectedTypeOption() {
      return this.jobTypes.find(jobType => jobType.id === this.selectedType)
    },
  },
  created() {
    this.jobTypes = JOB_TYPES
  },
  methods: {
    showLoader(value) {
      this.loading = value
    },
  }
}
</script>
